import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";

const ModalDetailsBadge = ({ open, setOpen, badgeData, type }) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle variant="h6" fontWeight="bold">
        Información del logro {badgeData?.nameBadge ?? ""}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={4}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Descripción:</Typography>
              <Typography>{badgeData?.description ?? "Sin dato"}</Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold"> Tipo de logro:</Typography>
              <Typography>{badgeData?.type ?? "Sin dato"} </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Box margin={2}>
              <Typography fontWeight="bold"> Membresía requerida:</Typography>
              <Typography>{badgeData?.membershipReq ?? "---"}</Typography>
            </Box>
            <Box margin={2}>
              <Typography fontWeight="bold"> Estatus:</Typography>
              <Typography color={badgeData?.isActive ? "green" : "red"}>
                {badgeData?.isActive ? "Activa" : "Inactiva"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalDetailsBadge;
